import { PartnerDto } from '../../model/partner-dto';
import { DateHelperService } from './../../services/date-helper.service';
import { GroupByPipe } from './../../pipes/group-by.pipe';
import { FulfillmentReportDto } from './../../model/fulfillment-report-dto';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Parentfullfillmentdto } from '../../model/parentfullfillmentdto';
import { ReportDateRangeWrapperDto } from './../../model/report-date-range-wrapper-dto';
import { ReportDateRangeDto } from 'src/app/model/report-date-range-dto';
import * as moment from 'moment';
import { extendMoment } from 'moment-range';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { ElementRef, ViewChild } from '@angular/core';  
import * as XLSX from 'xlsx';
import { ExcelFileService } from 'src/app/services/excel-file.service';

@Component({
  selector: 'app-fulfillmentreport',
  templateUrl: './fulfillmentreport.component.html',
  styleUrls: ['./fulfillmentreport.component.css']
})
export class FulfillmentreportComponent implements OnInit {
  maxMonthlyLocationDate: moment.Moment;
  monthlyLocationDateRange;
  monthlyLocationDateRangeStart;
  monthlyLocationDateRangeEnd;
  public mlrPaginationConfiguration;
  mlrPaginationcount = 25;
  isOpen = false;
  poCountTotalModal = 0;
  dateRangeFfmModal: Date = new Date();
  public mlrloading: boolean;
  partnerDtoList: PartnerDto[];
  partnerDtoListFilter: PartnerDto[];
  sortArray: FulfillmentReportDto[];
  isLocationUpArrow: boolean;
  isLocationDownArrow: boolean;
  fullfillmentDataList: FulfillmentReportDto[];
  fullfillmentDataCoreList: FulfillmentReportDto[];
  re: ReportDateRangeWrapperDto;
  reportDateRanges: ReportDateRangeDto[] = [];
  filterData: any[] = [];
  partnerModal;
  maxDate: Date;
  selectedMermDto: any = [];
  @ViewChild('TABLE', { static: false }) TABLE: ElementRef;
  title = 'Excel';
  partnerName: string;
  isLessOrMoreDate = '';
  isFutureDate = false;


  constructor(private httpclientService: HttpclientService, public groupByPipe: GroupByPipe, public orderByPipe: PoOrderByPipe,
              public appSettingService: AppSettingService, public dateHelperService: DateHelperService,
              private changeDetection: ChangeDetectorRef, public excelFileService: ExcelFileService) {
    // this.fulfillmentreport();
  }



  ngOnInit() {
   
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getMonth() + 1 );
    this.partnerModal = -1;
    this.getPartnerDataList();
    this.isLocationUpArrow = true;
    this.isLocationDownArrow = true;
    console.log('dateRangeFfmModal..' + this.dateRangeFfmModal.getMonth());
    console.log('dateRangeFfmModal..' + this.dateRangeFfmModal.getFullYear());

    //this.dateRangeFfmModal = moment().format('MM/YYYY');
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };
    // this.reportDateRanges = [{
    //       start: '2019-07-01',
    //       end: '2019-07-07',
    //     },
    //      {
    //       start: '2019-07-08',
    //       end: '2019-07-14',
    //     },
    //     {
    //       start: '2019-07-15',
    //       end: '2019-07-21',
    //     },
    //     {
    //       start: '2019-07-22',
    //       end: '2019-07-28',
    //     },
    //     {
    //       start: '2019-07-29',
    //       end: '2019-07-31',
    //     }
    //   ];

    //this.reportDateRanges = this.dateHelperService.
    //  getSelectedWeeks(this.dateRangeFfmModal.getFullYear(), this.dateRangeFfmModal.getMonth());
    this.getFulfillmentreport();
  }



  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.TABLE.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ScoreSheet.xlsx');
  }
  modalPopup : boolean=false;
  modalPopupString: string;
  pressingOK(){
    this.modalPopup=false;
  }
  exportFullfillmentReport() {
    if (this.fullfillmentDataList === null || this.fullfillmentDataList.length === 0) {
      this.modalPopupString="No Data to Export";
      this.modalPopup=true;
    } else {

    this.excelFileService.exportFullfillmentExcel(this.fullfillmentDataList, 'Fulfillment Report', this.reportDateRanges, this.partnerName,
                  this.dateRangeFfmModal);
  }
}

  selectePartner() {
    console.log('this.isLessOrMoreDate.trim.toString.length..'+this.isLessOrMoreDate.trim().toString.length);
    if (this.partnerDtoList && this.partnerModal && ! this.isFutureDate ) {
    this.partnerName = '';
    this.partnerDtoList.forEach(partner => {
      if (partner.partnerId === Number(this.partnerModal)) {
        this.partnerName = partner.partnerName;
      }
    });
    this.fullfillmentDataList = [];
    this.reportDateRanges = [];
    if (this.partnerModal !== -1) {
    this.reportDateRanges = this.dateHelperService.
        getSelectedWeeks(this.dateRangeFfmModal.getFullYear(), this.dateRangeFfmModal.getMonth());
    this.getFulfillmentreport();
    }
  }

}

  onChangeFfmSort(event: any, upDown: boolean, propertyName: string) {
    if (upDown) {
      console.log('calling  up..' + this.fullfillmentDataList);
      this.sortArray = [];
     
      this.mlrloading = true;
      this.sortArray = this.orderByPipe.transform(this.fullfillmentDataCoreList, 'customerLocationName', upDown);
      this.sortArray.forEach(pdto => {
        console.log('calling  up..' + pdto.customerLocationName);
      });
      this.sortArray = this.groupByPipe.transform(this.sortArray, 'customerLocationName');
      this.fullfillmentDataList = [];
      this.fullfillmentDataList =  this.sortArray;
      this.fullfillmentDataList.forEach(pdto => {
        this.mlrloading = false;
        console.log('calling  down..');
      });
      this.isLocationUpArrow = !this.isLocationUpArrow;
      this.isLocationDownArrow = true;
    } else {
      this.mlrloading = true;
      this.sortArray = [];
     
      this.sortArray = this.orderByPipe.transform(this.fullfillmentDataCoreList, 'customerLocationName', upDown);

      this.sortArray.forEach(pdto => {
        console.log('calling  down..' + pdto.customerLocationName);
      });
      this.sortArray = this.groupByPipe.transform(this.sortArray, 'customerLocationName');

      this.fullfillmentDataList = [];
      this.fullfillmentDataList =  this.sortArray;

      this.fullfillmentDataList.forEach(pdto => {
        this.mlrloading = false;
        console.log('calling  down..');
      });

    //  this.changeDetection.detectChanges();
      this.isLocationDownArrow = !this.isLocationDownArrow;
      this.isLocationUpArrow = true;
    }
    console.log('calling ..' + this.fullfillmentDataList);
  }

  // public trackItem (index: number, item: FulfillmentReportDto) {
  //   return item.locationId;
  // }

  dateRangFfmOnChange(value: Date): void {
    this.isLocationUpArrow = true;
    this.isLocationDownArrow = true;
    this.fullfillmentDataList = [];
    this.reportDateRanges = [];
    if (value !== null ) {
      if (this.dateHelperService.compareMonthAndYear(value, this.maxDate)) {
        this.isLessOrMoreDate = '';
        this.isFutureDate = false;
        this.reportDateRanges = this.dateHelperService.
        getSelectedWeeks(value.getFullYear(), value.getMonth());
        this.getFulfillmentreport();
      } else {
        this.isLessOrMoreDate = 'Future Month cannot be selected';
        this.isFutureDate = true;
      }
    }
  }


  totalPoCount(data, propertyName: string) {
    let total = 0;
    if (propertyName === 'rep_Count_of_PO') {
      data.forEach((d) => {
        total += parseInt(d.rep_Count_of_PO, 10);
      });
    } else if (propertyName === 'rep_Complete_Orders') {
      data.forEach((d) => {
        total += parseInt(d.rep_Complete_Orders, 10);
      });
    } else if (propertyName === 'rep_Bol_Not_Received') {
      data.forEach((d) => {
        total += parseInt(d.rep_Bol_Not_Received, 10);
      });
    } else if (propertyName === 'rep_partial_Orders') {
      data.forEach((d) => {
        total += parseInt(d.rep_partial_Orders, 10);
      });
    } else if (propertyName === 'rep_Sku_Quantity') {
      data.forEach((d) => {
        total += parseInt(d.rep_Sku_Quantity, 10);
      });
    } else if (propertyName === 'rep_Sku_Quantity_not_received') {
      data.forEach((d) => {
        total += parseInt(d.rep_Sku_Quantity_not_received, 10);
      });
    }

    return total;
  }


  getPartnerDataList() {
    this.isLocationUpArrow = true;
    this.isLocationDownArrow = true;
    this.mlrloading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          //this.partnerDtoList = data;
          this.appSettingService.partnerMSOGlobelList = data;
          this.partnerDtoList = data;
          this.mlrloading = false;
        }
      );

    //  console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.partnerDtoList = this.appSettingService.partnerMSOGlobelList;
        this.mlrloading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }



  monthlyLocationDateChange() {

  }
  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  getFulfillmentreport() {
    // this.re = '{"partnerId":7,"reportDateRanges":[{"start":"2019-09-01","end":"2019-09-01"},{"start":"2019-09-02","end":"2019-09-02"}]}';
   if (this.partnerModal !== -1) {
      this.mlrloading = true;
      this.re = {
        partnerId: this.partnerModal,
        reportDateRanges: this.reportDateRanges,
      };

      this.httpclientService.getFullfillmentReport(this.re).subscribe(
        data => {

          console.log('data..' + data.length);
          this.fullfillmentDataList = data;
          this.fullfillmentDataCoreList = data;
          if (data.length === 0  ) {
            this.mlrloading = false;

          } else {

            this.fullfillmentDataList = this.groupByPipe.transform(this.fullfillmentDataList, 'locationId');
            this.fullfillmentDataList.forEach(pdto => {
                this.mlrloading = false;
              });
          }

          //  this.filterData = this.groupByPipe.transform(this.fullfillmentDataList, 'locationId');

        }
      );
   }

  }


  /****************************************************** Pagination Start ***************************************************/
  mlrOnChangePagination(value) {

    this.mlrPaginationConfiguration.itemsPerPage = value;
    this.mlrPaginationcount = value;
  }

  mlrPageOnChanged(event) {
    this.mlrPaginationConfiguration.currentPage = event;
  }
  /****************************************************** Pagination End ***************************************************/



}
